/**
 * Hover replacement for touch devices - because :hover suuucks
 */
import jQuery from 'jquery';

if ('ontouchstart' in document.documentElement) {
    const reset_timeouts = {};
    const DELAY = 60;
    const RESET = 1000;
    var events = {
        touchstart(e) {
            reset_timeouts[e.currentTarget] = setTimeout(function() {
                jQuery(e.currentTarget).addClass('m2g-touching');
                reset_timeouts[e.currentTarget] = setTimeout(function() {
                    events.touchend(e);
                }, RESET);
            }, DELAY);
        },
        touchend(e) {
            clearTimeout(reset_timeouts[e.currentTarget]);
            jQuery(e.currentTarget).removeClass('m2g-touching');
        },
    };

    jQuery('.m2g-view')
        .delegate('.m2g-touchable', events)
        .addClass('m2g-view--touch');
}
